import {texture} from "p3";
import definitions from "../../../definitions";
import Item from "./Item";

export default class ItemCollectionJarPearls extends Item {
    constructor() {
        super(definitions.ITEM_ID.COLLECTION_JAR_PEARLS_FULL, texture("prop_jar_of_pearls_00"));
    }

    init() {
        super.init();

        this.addShadow(definitions.SHADOW_SIZE.MEDIUM, 0.6, new PIXI.Point(3, 0));
    }
}